<template>
  <div class="gw-popup">
    <div class="gw-popup__content">
      <button class="gw-popup__close" @click="close"></button>
      <section class="gw-form">
        <div class="gw-form__heading">
          <a class="gw-form__logo" href="//my.games/"></a>
        </div>
        <div class="gw-form__content">
          <h3 class="gw-form__title">{{ $t("mygames.title") }}</h3>

          <div class="gw-form__agreement-block">
            <div class="gw-form__block">
              <div v-if="canUserSubscribe" class="gw-form__checkbox gw-checkbox">
                <input
                  id="gw-mail-agreement"
                  v-model="subscription"
                  class="gw-checkbox__input"
                  type="checkbox"
                />
                <label class="gw-checkbox__label" for="gw-mail-agreement">
                  <span class="gw-form__agreement gw-form__agreement_lg">{{
                    $t("mygames.email_agreement")
                  }}</span>
                </label>
              </div>

              <div class="gw-form__checkbox gw-checkbox">
                <input
                  id="gw-terms-agreement"
                  v-model="agree"
                  class="gw-checkbox__input"
                  type="checkbox"
                />
                <label class="gw-checkbox__label" for="gw-terms-agreement">
                  <span
                    class="gw-form__agreement gw-form__agreement_lg"
                    v-html="$t('mygames.terms_agreement')"
                  ></span>
                </label>
              </div>
            </div>
          </div>

          <div class="gw-form__submit">
            <button class="gw-form__btn gw-btn" :disabled="!agree" @click="userRegister">
              {{ $t("mygames.button") }}
            </button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import env from "@libs/util/environment";
import Cookie from "js-cookie";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      subscription: false,
      agree: false,
      mail_subscribe_whitelist: [
        "bk.ru",
        "mail.ru",
        "mail.ua",
        "corp.mail.ru",
        "list.ru",
        "inbox.ru",
      ],
    };
  },

  computed: {
    ...mapGetters("global", ["getUserData", "getProjectUserEmail"]),

    canUserSubscribe() {
      const user_email_domain = this.getProjectUserEmail.split("@")[1];

      return this.mail_subscribe_whitelist.includes(user_email_domain);
    },
  },

  methods: {
    userRegister() {
      let registration_url = `/dynamic/auth/?confirm_reg=true&language=${env.getLang()}`;

      // For ru terrotiry
      Cookie.set("confirm_reg", +new Date());

      if (this.subscription) {
        registration_url += "&notifications=true";
      }

      fetch(registration_url, {
        method: "POST",
      }).then(() => {
        Cookie.set("new_user", 1, { expires: 1 });
        location.reload();
      });
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="stylus">
@font-face {
  font-family: 'Roboto';
  src: url('//store.my.games/hotbox/gem_static/leela/v185/Roboto-Regular.woff') format('woff'); // store.my.games/hotbox/gem_static/leela/v185/Roboto-Regular.woff) format('woff')
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Roboto';
  src: url('//store.my.games/hotbox/gem_static/leela/v185/Roboto-Medium.woff') format('woff'); // store.my.games/hotbox/gem_static/leela/v185/Roboto-Medium.woff) format('woff')
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Roboto';
  src: url('//store.my.games/hotbox/gem_static/leela/v185/Roboto-Light.woff') format('woff'); // store.my.games/hotbox/gem_static/leela/v185/Roboto-Light.woff) format('woff')
  font-weight: 300;
  font-style: normal;
}

*, :after, :before {
  box-sizing: border-box;
}

.gw-popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1200;
  padding: 20px 0;
  height: auto;
  text-align: center;
  background-color: rgba(3, 3, 3, 0.6);
  cursor: pointer;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-smoothing: antialiased;
}

.gw-popup__content {
  position: relative;
  z-index: 1;
  cursor: auto;
}

.gw-popup__close {
  display: block;
  position: absolute;
  z-index: 5;
  top: 20px;
  right: 20px;
  padding: 0;
  width: 16px;
  height: 16px;
  background-color: transparent;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%23FFF' fill-rule='evenodd' d='M10.138 8l5.419 5.42c.59.59.59 1.547 0 2.138-.591.59-1.548.59-2.139 0L8 10.138l-5.418 5.42c-.591.59-1.548.59-2.139 0a1.514 1.514 0 0 1 0-2.139L5.863 8 .442 2.58a1.51 1.51 0 0 1 0-2.137 1.51 1.51 0 0 1 2.137 0L8 5.863l5.42-5.42a1.51 1.51 0 0 1 2.137 0c.59.59.59 1.548 0 2.137L10.137 8z' /%3E%3C/svg%3E");
  background-size: 16px;
  border: none;
  outline: none;
  appearance: none;
  cursor: pointer;
  opacity: 0.3;
  transition: opacity 0.1s;
}

.gw-form {
  font-family: 'Roboto', Arial, Helvetica, Helvetica Neue, sans-serif;
  margin: 0;
  font-size: 15px;
  line-height: normal;
  text-align: left;
  // width 500px
  width: auto;
  max-width: 650px;
  min-width: 320px;
  height: 100%;
  color: #898989;
  background-color: #323236;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}

.gw-form__heading {
  padding: 12px 60px 13px;
  font-size: 22px;
  line-height: 1.45;
  color: #f5f5f7;
  background-color: #242429;
  border-radius: 6px 6px 0 0;
}

.gw-form__logo {
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3Csvg version='1.1' id='Artwork' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 839.1 283.5' enable-background='new 0 0 839.1 283.5' xml:space='preserve' fill='%23FFFFFF'%3E%3Cg%3E%3Cpolygon points='88.1,173.2 56.7,138.3 130,56.8 171.1,102.5 212.3,56.7 260.4,110.2 308.5,56.8 340.2,92 219,226.8 187.3,191.6 228.7,145.5 212.1,127 170.7,173 129.5,127.2 '/%3E%3Cg%3E%3Cpolygon points='466.9,120.5 451.1,143.9 434.6,120.5 422.8,120.5 446,153.2 446,173 456,173 456,153.2 478.5,120.5 '/%3E%3Cpath d='M522,143.3v9.2h17.1v10.2c-3.8,1.1-8.3,1.7-12.6,1.7c-13.2,0-21-6.5-21-17.5c0-10.5,8.5-17.5,21-17.5 c6,0,12.3,1.3,18.1,3.8l0.9,0.4l3.1-8.7l-0.8-0.3c-7.2-3-14.5-4.5-22-4.5c-18.4,0-30.8,11-30.8,27.3c0,16.5,11.6,26.4,31.1,26.4 c7.7,0,16.5-1.8,22.5-4.6l0.5-0.3v-25.6H522z'/%3E%3Cpolygon points='703.8,163.8 703.8,151 729.2,151 729.2,141.8 703.8,141.8 703.8,129.7 731.8,129.7 731.8,120.5 693.7,120.5 693.7,173 732.2,173 732.2,163.8 '/%3E%3Cpath d='M762.4,142c-7.8-1.1-12.6-2.1-12.6-6.5c0-3.8,3.9-6,10.8-6c7.2,0,13.5,2.7,15.8,3.9l0.9,0.4l4-8.1l-0.8-0.4 c-5.5-3.2-13.1-5.1-20.4-5.1c-13,0-20.7,5.9-20.7,15.9c0,4.8,1.6,8.3,5,10.8c4.1,3,10.1,3.9,15.5,4.6c7.5,1.1,12.1,1.9,12.1,6 c0,6.4-9.1,7.1-13,7.1c-5.8,0-11.2-1.5-16-4.4l-0.8-0.5l-4.6,8.2l0.7,0.5c3.9,2.6,10.7,5.6,20.7,5.6c14.3,0,23.5-6.6,23.5-16.9 C782.4,144.8,771.3,143.2,762.4,142'/%3E%3Cpolygon points='367.7,173 377.9,144 395.1,172.9 412.3,144 422.6,173 433.1,173 414.7,120.1 395.1,153.1 375.5,120.1 357.2,173 '/%3E%3Cpath d='M564.1,173l5.4-9.7l24.5,0l5.4,9.7h11.4l-29-52.9l-29,52.9H564.1z M581.7,141.4l7.8,14h-15.5L581.7,141.4z'/%3E%3Cpolygon points='623.6,173 633.8,143.2 651.1,172.9 668.3,143.2 678.5,173 689,173 670.6,120.1 651.1,153.1 631.5,120.1 613.1,173 '/%3E%3Crect x='472.3' y='158.5' transform='matrix(0.7071 -0.7071 0.7071 0.7071 23.6202 386.6928)' width='12.7' height='12.7'/%3E%3C/g%3E%3Cpath d='M297.9,163.6c-2.8,0-5.1,2.3-5.1,5.1c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1C303,165.8,300.7,163.6,297.9,163.6z M297.9,173.1c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C302.3,171.1,300.3,173.1,297.9,173.1z M300.1,171.1 c0-0.1,0-0.3,0-0.4v-0.4c0-0.3-0.1-0.6-0.3-0.9c-0.2-0.3-0.5-0.5-1-0.5c0.3-0.1,0.6-0.1,0.8-0.3c0.4-0.2,0.5-0.6,0.5-1.1 c0-0.7-0.3-1.2-0.9-1.4c-0.3-0.1-0.8-0.2-1.5-0.2h-2v5.6h1v-2.2h0.8c0.5,0,0.9,0.1,1.1,0.2c0.4,0.2,0.5,0.6,0.5,1.3v0.4l0,0.2 c0,0,0,0,0,0.1c0,0,0,0,0,0.1h0.9l0-0.1C300.2,171.3,300.2,171.2,300.1,171.1z M298.7,168.4c-0.2,0.1-0.5,0.1-0.9,0.1h-0.9v-2h0.8 c0.5,0,0.9,0.1,1.2,0.2c0.2,0.1,0.4,0.4,0.4,0.8C299.3,168,299.1,168.3,298.7,168.4z'/%3E%3C/g%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  background-size: auto 80px;
  background-position: center;
  text-align: center;
  height: 50px;
  cursor: pointer;
  display: block;
}

.gw-form__title {
  margin: 0 0 20px;
  font-size: 20px;
  font-weight: 500;
  word-wrap: break-word;
  color: #fff;
}

.gw-form__content {
  padding: 20px 60px 25px;
  flex: 1 0 auto;

  @media (max-width: 650px) {
    padding: 20px 20px 25px;
  }
}

.gw-form__subtitle {
  margin-bottom: 26px;
  word-wrap: break-word;
  color: #c3c3c3;

  strong {
    color: #f5f5f7;
  }

  a {
    color: #16a7ff;

    &:hover {
      color: #56bfff;
    }
  }
}

.gw-form__subtitle_oauth {
  margin-bottom: 15px;
}

.gw-form__agreement-block {
  margin-top: 20px;

  .gw-checkbox__label {
    &:before {
      top: 4px;
    }
  }
}

.gw-form__block {
  margin-bottom: 15px;
  min-height: 1.33em;

  &:after {
    content: '';
    display: table;
    clear: both;
  }
}

.gw-form__block:last-child, .gw-form__field:last-child {
  margin-bottom: 0;
}

.gw-form__checkbox {
  display: inline-block;
  vertical-align: top;
  margin-bottom: 10px;

  &:not(:last-child) {
    margin-right: 27px;
  }
}

.gw-checkbox__input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  cursor: pointer;
}

.gw-checkbox__label {
  position: relative;
  display: inline-block;
  padding-left: 30px;
  line-height: 1.4;
  color: #d4d4d4;
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    background-color: #3c3c40;
    border: 1px solid #626262;
    border-radius: 3px;
  }
}

.gw-checkbox__input:checked + .gw-checkbox__label:before {
  background-color: #e2e3e7;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M7.7.3c-.4-.4-1-.4-1.4 0L3 3.6 1.7 2.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l2 2c.2.2.4.3.7.3.3 0 .5-.1.7-.3l4-4c.4-.4.4-1 0-1.4z'/%3E%3C/svg%3E");
  background-size: 10px 7px;
  background-repeat: no-repeat;
  background-position: center;
  border-color: #e2e3e7;
}

.gw-form__agreement {
  display: inline-block;
  font-size: 13px;
  line-height: 1.54;
  color: #ababae;

  a {
    text-decoration: none;
    transition: color 0.1s;
    color: #f5f5f7;

    &:visited {
      color: #f5f5f7;
    }

    &:hover, &:focus, &:active {
      color: #ababae;
    }
  }
}

.gw-form__agreement_lg {
  font-size: 14px;
}

.gw-form__submit {
  margin: 26px auto 0;
}

.gw-form__btn {
  padding: 8px 15px;
  width: 100%;
  min-height: 48px;

  &.gw-btn_link {
    padding: 0;
    width: auto;
    min-height: 32px;
  }

  &.gw-btn {
    &:not(.gw-btn_link):hover {
      &:after {
        transform: translate3d(-55%, calc(100% - 38px), 0) rotate(-15deg);
      }
    }
  }

  & + .gw-form__btn {
    margin-top: 11px;
  }
}

.gw-btn {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  padding: 4px 15px;
  font-size: 16px;
  line-height: 2;
  font-family: 'Roboto', Arial, Helvetica, Helvetica Neue, sans-serif;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  text-decoration: none;
  text-overflow: ellipsis;
  text-shadow: none;
  background-color: #e2e3e7;
  border: none;
  border-radius: 4px;
  outline: none;
  overflow: hidden;
  appearance: none;
  cursor: pointer;
  transition: all 0.1s;
  user-select: none;

  &:hover {
    background-color: #c7c8cb;

    &:before {
      left: 0;
      transform: translate3d(-50%, calc(-100% - 3px), 0px) rotate(-15deg);
    }

    &:after {
      left: 100%;
      transform: translate3d(-50%, calc(100% - 38px), 0) rotate(-15deg);
    }
  }

  &:active {
    background-color: #9a9a9d;
  }
}

.gw-btn, .gw-btn:link, .gw-btn:visited, .gw-btn:hover, .gw-btn:focus, .gw-btn:active {
  color: #000;
}

.gw-btn:disabled, .gw-btn_disabled {
  color: #262626;
  background-color: #414141;
  pointer-events: none;
  cursor: default;
  transition: none;
}

.gw-btn:before, .gw-btn:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 150%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transform: translate3d(-50%, -50%, 0) rotate(-15deg);
  transition: opacity 0.2s easeout, left 0s 0.3s, -webkit-transform 0.3s cubic-bezier(1, 0, 0, 1);
  transition: opacity 0.2s easeout, transform 0.3s cubic-bezier(1, 0, 0, 1), left 0s 0.3s;
}

.gw-btn:hover:before, .gw-btn:hover:after {
  opacity: 1;
  transition: opacity 0.3s easeout, -webkit-transform 0.2s cubic-bezier(1, 0, 0, 1);
  transition: opacity 0.3s easeout, transform 0.2s cubic-bezier(1, 0, 0, 1);
}
</style>
